import {decomposeColor, recomposeColor} from '@mui/material';

function normalizeValue(value: number, min: number, max: number) {
  if (value >= max) {
    return 1;
  }
  if (value <= min) {
    return -1;
  }
  const weight = (value - min) / (max - min);
  return -1 + 2 * weight;
}

function blendColors(color1: string, color2: string, weight: number) {
  const _color1 = decomposeColor(color1);
  const _color2 = decomposeColor(color2);
  const rgb: [number, number, number] = [
    Math.round(_color1.values[0] * (1 - weight) + _color2.values[0] * weight),
    Math.round(_color1.values[1] * (1 - weight) + _color2.values[1] * weight),
    Math.round(_color1.values[2] * (1 - weight) + _color2.values[2] * weight),
  ];
  return recomposeColor({type: 'rgb', values: rgb});
}

export function normalizeColor(
  value: number,
  min: number,
  max: number,
  minColor: string,
  midColor: string,
  maxColor: string,
): string {
  const weight = normalizeValue(value, min, max);
  if (weight >= 0) {
    return blendColors(midColor, maxColor, weight);
  }
  return blendColors(midColor, minColor, -weight);
}
